/**
 * Layout: Hero - Solliciteren
 * Slug: hero_solliciteren
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.hero_solliciteren-layout');

	layouts.forEach((layout) => {
		
	});
});
